import React from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import Login from "../pages/admin/Login";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import PostsList from "../pages/admin/PostsList";
import Home from "../pages/frontView/Home";
import CategoriesList from "../pages/admin/CategoriesList";
import VisaTypesList from "../pages/admin/VisaTypesList";
import LocationsList from "../pages/admin/LocationsList";
import Carousel from "../pages/admin/Carousel";
import ImagesList from "../pages/admin/ImagesList";
import ForgotPassword from "../pages/admin/ForgotPassword";
import ResetPassword from "../pages/admin/ResetPassword";
import AuthRoutes from "./AuthRoutes";
import CreateNewPost from "../pages/admin/CreateNewPost";
import PostDetail from "../pages/admin/PostDetail";
import Jobs from "../pages/frontView/Jobs";
import About from "../pages/frontView/About";
import JobDetailAndRelated from "../pages/frontView/JobDetailAndRelated";
import NotFound from "../pages/NotFound";

const RedirectPublicRoutes: React.FC = () => {
  const { page } = useParams<{ page?: string }>();

  switch (page) {
    case undefined:
      return <Home />;
    case "jobs":
      return <Jobs />;
    case "about-us":
      return <About />;
    default:
      return <NotFound/>;
  }
};

const RedirectAdminRoutes: React.FC = () => {
  const { page } = useParams<{ page: string }>();

  switch (page) {
    case "create-new-post":
      return <CreateNewPost />;
    case "posts":
      return <PostsList />;
    case "categories":
      return <CategoriesList />;
    case "visa-types":
      return <VisaTypesList />;
    case "locations":
      return <LocationsList />;
    case "carousel":
      return <Carousel />;
    case "images":
      return <ImagesList />;
    default:
      return <NotFound/>;
  }
};

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicRoutes />}>
          <Route index element={<Home />} />
          <Route path=":page" element={<RedirectPublicRoutes />} />
          <Route path="jobs/:id" element={<JobDetailAndRelated/>}></Route>
        </Route>
        <Route element={<AuthRoutes />}>
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password/:verifyToken" element={<ResetPassword />} />
        </Route>
        <Route path="admin" element={<PrivateRoutes />}>
          <Route path=":page" element={<RedirectAdminRoutes />} />
          <Route path="posts/:id" element={<PostDetail/>}></Route>
        </Route>
        <Route path="*" element={<NotFound/>} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
